import React, { Fragment } from "react";
import { Dialog, Grid, TextField } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import styled from "styled-components";
import { PrimaryButton, SecondaryButton, ButtonSizeOptions } from '@loanbossinc/component-library';

const PaddedDiv = styled.div`
  padding: 30px 10px 10px 30px;
`;

const styles = () => ({
    labelRoot: {},
    inputField: {
        borderBottom: "1px solid #2196F3",
    },
    error: {
        '& input': {
            borderBottom: '1px solid red'
        }
    }
});


const StyledDialog = styled.div`
width: 480px;
height: 300px;
`;

const StyledPrimaryButton = styled(PrimaryButton)`&&&{
    margin-left: 24px;
}`;

const StyledTitle = styled.div`
    font-family: Work Sans;
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 28px;
    display: flex;
    align-items: center;
    color: #000000;
    margin-left: 24px;
    margin-top: 36px;
 `;

const modalTitle = "Add Summary";

class AddSummaryModal extends React.Component {
    state = { 
        summaryText: "" 
    }
    componentDidUpdate(prevProps) {
        if (prevProps.summaryText !== this.props.summaryText || prevProps.field !== this.props.field)
            this.setState({
                summaryText: !this.props.summaryText ? "" : this.props.summaryText
            })
    }
    handleChange = (name, data) => this.setState({ summaryText: data.value });

    closeModal = () => this.props.onClose();
    onCancel = () => this.props.onClose();
    save = () => {
        const { field } = this.props;
        const { summaryText } = this.state;
        this.props.onSave(field, summaryText);
        this.closeModal();
    }

    render() {
        const { isOpen, classes, field } = this.props;
        const { summaryText } = this.state;

        return (
            <StyledDialog>
                <Dialog open={isOpen} onClose={this.closeModal} fullWidth maxWidth="sm" id="addSummaryModal">
                    <Grid container direction="row" alignItems="center" justify="space-between" >
                        <StyledTitle id="modelHeader">{modalTitle}</StyledTitle>
                    </Grid>

                    <PaddedDiv>
                        <Fragment>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <TextField
                                    id="summaryField"
                                    multiline
                                    fullWidth
                                    value={summaryText}
                                    label="Write a summary to attach to this loan section"

                                    onChange={event => this.handleChange("summaryText", event.target)}
                                />
                            </div>
                            <Grid container direction="row" justify="flex-end">
                                <SecondaryButton label="Cancel" size={ButtonSizeOptions.sm} onClick={this.onCancel} style={{ marginTop: '16px' }} />
                                <StyledPrimaryButton disabled={false} label="Save" size={ButtonSizeOptions.sm} onClick={this.save} style={{ marginTop: '16px' }} />
                            </Grid>
                        </Fragment>
                    </PaddedDiv>
                </Dialog>
            </StyledDialog>
        );
    }
}

export default withStyles(styles)(AddSummaryModal);
